const map = {
	"./de": [
		5089,
		[
			5089
		]
	],
	"./de.json": [
		5089,
		[
			5089
		]
	],
	"./en": [
		517,
		[
			517
		]
	],
	"./en.json": [
		517,
		[
			517
		]
	],
	"./fr": [
		1254,
		[
			1254
		]
	],
	"./fr.json": [
		1254,
		[
			1254
		]
	],
	"./nl": [
		6872,
		[
			6872
		]
	],
	"./nl.json": [
		6872,
		[
			6872
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3310;
module.exports = webpackAsyncContext;